/**
 * @fileoverview GET handler for the "/companies/:company_id/custom_domains/:domain_type/:domain_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomDomainsDomainTypeDomainId } from "./constants";
import type { CustomDomain } from "./types";
import { isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResult } from "./validators";

export const getCompaniesCompanyIdCustomDomainsDomainTypeDomainId = reactQueryFetcherAdapter(
  companiesCompanyIdCustomDomainsDomainTypeDomainId,
  (signal: AbortSignal, companyId: string, domainType: string, domainId: string): Promise<CustomDomain> => {
    return fetch(`/companies/${companyId}/custom_domains/${domainType}/${domainId}`, "GET", {}, { signal });
  },
  isCompaniesCompanyIdCustomDomainsDomainTypeDomainIdResult
);
